<img src="../../../../assets/images/logos/logo-minimal.png" alt="UPS">
<span class="title" [innerHtml]="'priceComparison.title' | translate"></span>
<span class="message" [innerHtml]="'priceComparison.message' | translate"></span>
<a href="#"
   class="request-quote"
   role="button"
   (click)="requestQuote($event)"
   [innerHtml]="'priceComparison.requestQuote' | translate"></a>